export default __webpack_public_path__ + "static/media/fan-galleries1.08034816.jpg";